import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Manifesto from "@/components/site/Manifesto";
import Experience from "@/components/site/Experience";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Brands from "@/components/site/Brands";
import Achievements from "@/components/site/Achievements";
import Skills from "@/components/site/Skills";
import Education from "@/components/site/Education";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Portfolio() {
  return (
    <main className="relative bg-obsidian text-white overflow-x-hidden" data-testid="portfolio-root">
      <div className="grain" aria-hidden />
      <Nav />
      <Hero />
      <Manifesto />
      <Experience />
      <Marquee />
      <Services />
      <Brands />
      <Achievements />
      <Skills />
      <Education />
      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
}
